import styled from 'styled-components'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { IppTrustBarLogo } from 'components/Common/TrustIndicators/IppLogo'

const Container = styled(Group)`
  min-width: 50%;

  ${mediaQueryUp.desktop} {
    min-width: unset;
  }
`

function IppTrustIndicator() {
  return (
    <Container direction="vertical" horizontalAlign="center" verticalAlign="center">
      <IppTrustBarLogo />
    </Container>
  )
}

export default IppTrustIndicator
